function getLink(
	isProjectGroup: boolean,
	linkId?: string | null,
	clearSubPath?: boolean,
	disableLink?: boolean
): string | undefined {
	if (!linkId || disableLink) return undefined;

	const path = isProjectGroup ? `/connected/X-${linkId}` : `/project/${linkId}`;

	const curLocArr = window.location.href.split('/');
	const pageName = curLocArr[curLocArr.length - 1];
	const subPath = clearSubPath ? '' : `/${pageName}`;
	return `${path}${subPath}`;
}

export function getProjectLink(linkId?: string | null, clearSubPath?: boolean, disableLink?: boolean): string | undefined {
	return getLink(false, linkId, clearSubPath, disableLink);
}

export function getProjectGroupLink(linkId?: string, clearSubPath?: boolean, disableLink?: boolean): string | undefined {
	return getLink(true, linkId, clearSubPath, disableLink);
}

function withProjectPrefix(companyProjectId: number | null | undefined): string {
	if (!companyProjectId) return '';

	return `${'P'}${companyProjectId}`;
}

/**
 * Please consider using the ProjectIndicator or at least DeprecatedProjectIndicator component instead of this function - it renders the project indicator using the project color.
 * */
export function getProjectIndicatorString(companyProjectId?: number | null, customProjectId?: string | null): string {
	return customProjectId ? customProjectId : withProjectPrefix(companyProjectId);
}

function withProjectGroupPrefix(companyProjectId: number | null | undefined): string {
	if (!companyProjectId) return '';

	return `${'X'}${companyProjectId}`;
}

export function getProjectGroupIndicatorString(companyProjectGroupId?: number): string {
	return withProjectGroupPrefix(companyProjectGroupId);
}

export type ProjectOrProjectGroupIndicatorStringArgs = {
	companyProjectId?: number;
	customProjectId?: string;
	companyProjectGroupId?: number;
	name?: string;
};

/**
 * Please consider using the ProjectGroupIndicator or at least DeprecatedProjectGroupIndicator component instead of this function - it renders the project indicator using the project color.
 * */
export function getProjectOrProjectGroupIndicatorString({
	companyProjectId,
	customProjectId,
	companyProjectGroupId,
	name,
}: ProjectOrProjectGroupIndicatorStringArgs): string {
	const id = companyProjectGroupId
		? getProjectGroupIndicatorString(companyProjectGroupId)
		: getProjectIndicatorString(companyProjectId, customProjectId);
	return name ? `${id} - ${name}` : id;
}
